<div class="modal-header" *ngIf="title">
  <div class="label-name">{{title}}</div>
  <div class="modal-close-x" (click)="close()"><fa-icon [icon]="closeIcon"></fa-icon></div>
</div>
<div class="modal-body p-0">
  <kh-video-with-events [videoId]="videoId"></kh-video-with-events>
  
  <div class="p-3" *ngIf="description" [textContent]="description"></div>

</div>
